import React, { Fragment, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Label from 'components/_utility/Label';
import Close from 'src/assets/icons/close.svg';
import ChevronRight from 'src/assets/icons/chevron-right.svg';
import { appendModalToDom } from 'helpers/modal';
import { bodyNoScroll } from 'helpers/utilities';
import {
  ConfigOptionsContainer,
  ConfigOptions,
  ConfigOptionsLink,
  ConfigOptionsLinkA,
  Icon,
  ConfigOptionsHeader,
  ConfigOptionsTitle,
  ConfigOptionsLabelWrapper,
  ConfigOptionsCloseButton,
  ConfigOptionsBackButtonWrapper,
  ConfigOptionsBackButton,
  GarageCount,
} from '../Tray.styled';

const TrayOptions = ({ modalOpen, onCloseTrayModal = () => {}, options = [] }) => (
  <ConfigOptionsContainer trayModalOpen={modalOpen}>
    <ConfigOptionsHeader>
      <ConfigOptionsTitle>
        <Label name="configuratorLabel" />
      </ConfigOptionsTitle>
      <ConfigOptionsCloseButton onClick={onCloseTrayModal}>
        <Close />
      </ConfigOptionsCloseButton>
    </ConfigOptionsHeader>

    {options.map(({ ...option }) => {
      const linkProps = {};

      if (option.link) {
        linkProps.target = '_blank';
        linkProps.href = option.link;

        if (option.onClick) {
          linkProps.onClick = option.onClick;
        }
      }

      const LinkEl = option.link ? ConfigOptionsLinkA : ConfigOptionsLink;

      if (!option.link && option.conditional) {
        return null;
      }

      return (
        <Fragment key={option.id}>
          {option.link ? (
            <LinkEl {...linkProps}>
              <Icon src={option.icon}></Icon>
              <ConfigOptionsLabelWrapper>
                <Label name={option.label} />
              </ConfigOptionsLabelWrapper>
              <ChevronRight />
            </LinkEl>
          ) : (
            option.link !== null &&
            !option.hidden && (
              <ConfigOptions onClick={option.onClick} disabled={option.disabled}>
                <Icon src={option.icon}></Icon>
                {option.count ? <GarageCount>{option.count}</GarageCount> : null}
                <ConfigOptionsLabelWrapper>
                  <Label name={option.label} />
                </ConfigOptionsLabelWrapper>
                <ChevronRight />
              </ConfigOptions>
            )
          )}
        </Fragment>
      );
    })}
    <ConfigOptionsBackButtonWrapper>
      <ConfigOptionsBackButton onClick={onCloseTrayModal}>
        <Label name="backLabel" />
      </ConfigOptionsBackButton>
    </ConfigOptionsBackButtonWrapper>
  </ConfigOptionsContainer>
);

const configuratorTrayPopupEl = appendModalToDom('configurator-tray-popup');

export const TrayOptionsPortal = ({ ...props }) => {
  useEffect(() => {
    configuratorTrayPopupEl.style.display = 'block';

    return () => {
      configuratorTrayPopupEl.style.display = 'none';
      bodyNoScroll.remove();
    };
  }, []);

  return createPortal(<TrayOptions {...props} />, configuratorTrayPopupEl);
};

export default TrayOptions;
